import React from 'react'

export default function Orders() {
  return (
    <div>
      orders
    </div>
  )
}
